var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--mypage"
  }, [_vm.scope.includes('seller') ? _c('sub-visual', {
    attrs: {
      "visual": _vm.$t('common.셀러 회원 마이페이지')
    }
  }) : _vm._e(), _vm.scope.includes('buyer') ? _c('sub-visual', {
    attrs: {
      "visual": _vm.$t('common.바이어 회원 마이페이지')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('div', {
    staticClass: "mypage-container"
  }, [_c('mypage-navigation'), _c('div', {
    staticClass: "mypage-contents"
  }, [_c('div', {
    staticClass: "mypage-contents__head"
  }), _c('div', {
    staticClass: "mypage-contents__body"
  }, [_c('div', {
    staticClass: "text-ecplain mb-3"
  }, [_c('p', [_vm._v("상품 정보 수정이 필요하신 경우 "), _c('strong', [_vm._v("각 상품 내")]), _vm._v("에서 직접 수정을 부탁드립니다.")])]), _c('product-list', {
    attrs: {
      "type": "me",
      "show-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var products = _ref.products;
        return _vm._l(products, function (product) {
          return _c('product-list-item', {
            key: product._id,
            attrs: {
              "product": product,
              "to": `/mypage/products/${product._id}`
            }
          });
        });
      }
    }])
  })], 1)])], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }